module.exports = __webpack_public_path__ + "media/images/area/feature/kansai/03-7f9446bc54ac56503479ad1234426802.jpg";